export const DEALERS_CREATE_EDIT_DEALER_OPEN_MODAL = "DEALERS_CREATE_EDIT_DEALER_OPEN_MODAL";
export const DEALERS_CREATE_EDIT_DEALER_CLOSE_MODAL = "DEALERS_CREATE_EDIT_DEALER_CLOSE_MODAL";
export const DEALERS_CREATE_DEALER_REQUEST = "DEALERS_CREATE_DEALER_REQUEST";
export const DEALERS_CREATE_DEALER_RESULT = "DEALERS_CREATE_DEALER_RESULT";
export const DEALERS_EDIT_DEALER_REQUEST = "DEALERS_EDIT_DEALER_REQUEST";
export const DEALERS_EDIT_DEALER_RESULT = "DEALERS_EDIT_DEALER_RESULT";

export const DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST = "DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_REQUEST";
export const DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_RESULT = "DEALERS_CREATE_EDIT_DEALER_SEARCH_ROLES_RESULT";

export const DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST = "DEALERS_CREATE_EDIT_DEALER_GET_ROLE_REQUEST";
export const DEALERS_CREATE_EDIT_DEALER_GET_ROLE_RESULT = "DEALERS_CREATE_EDIT_DEALER_GET_ROLE_RESULT";

export const DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST = "DEALERS_CREATE_EDIT_DEALER_GET_DEALER_REQUEST";
export const DEALERS_CREATE_EDIT_DEALER_GET_DEALER_RESULT = "DEALERS_CREATE_EDIT_DEALER_GET_DEALER_RESULT";

export const DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST = "DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_REQUEST";
export const DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_RESULT = "DEALERS_CREATE_EDIT_DEALER_GET_CUSTOM_ROLE_RESULT";

export const DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST = "DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_REQUEST";
export const DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_RESULT = "DEALERS_CREATE_EDIT_DEALER_GET_ROLE_MODULES_TEMPLATE_RESULT";

export const DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST = "DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_REQUEST";
export const DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_RESULT = "DEALERS_CREATE_EDIT_DEALER_SEARCH_TIMEZONES_RESULT";

export const DEALERS_CREDENCIAL_VALIDATION_REQUEST = "DEALERS_CREDENCIAL_VALIDATION_REQUEST";
export const DEALERS_CREDENCIAL_VALIDATION_RESULT = "DEALERS_CREDENCIAL_VALIDATION_RESULT";


